export default "__VITE_ASSET__DJlI018F__"